import { TransportManagerAccountProfileComponent } from "./transport-manager-account-profile/transport-manager-account-profile.component";
import { TransportManagerAccountComponent } from "./transport-manager-account.component";
import { TransportManagerChangePasswordComponent } from "./transport-manager-change-password/transport-manager-change-password.component";

export const transportManagerAccountRouting = [
   
    { path: '', redirectTo: 'profile', pathMatch: 'full'},
    { path:'profile', component:TransportManagerAccountProfileComponent},
    { path: 'changePassword', component:TransportManagerChangePasswordComponent},
    
];

export const TransportManagerAccountBreadcrumbs = [
    { name: 'Change Password', path: '/changePassword' }, 
];